import * as React from 'react';
import { FC, ReactElement } from 'react';

import { PullToReload, PullToReloadContent } from 'components/pull-to-reload';

import { LoyaltyLoadingAnimation, LoyaltyPullDownLoader } from '../loyalty-lottie-animations';

interface ILoyaltyPullToReload {
  onRefresh(): Promise<any>;
  enabled?: boolean;
  refreshContent?: ReactElement;
}

const LoyaltyPullToReload: FC<ILoyaltyPullToReload> = ({
  onRefresh,
  children,
  enabled,
  refreshContent,
}) => {
  return (
    <PullToReload
      pullDownThreshold={100}
      triggerHeight={500}
      startInvisible
      enabled={enabled}
      onRefresh={onRefresh}
      pullDownContent={
        <PullToReloadContent action="pullingDown" animationData={LoyaltyPullDownLoader} />
      }
      releaseContent={
        <PullToReloadContent action="releasing" animationData={LoyaltyPullDownLoader} />
      }
      refreshContent={
        refreshContent ?? (
          <PullToReloadContent action="refreshing" animationData={LoyaltyLoadingAnimation} />
        )
      }
    >
      {children}
    </PullToReload>
  );
};

export default LoyaltyPullToReload;
